import { PropsWithChildren } from "react";

interface TableCellProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {}

export const TableCell = ({ children, ...props }: TableCellProps) => {
  return (
    <div
      className="flex flex-row items-center h-fit min-h-12 max-h-24 p-4"
      // borderBottom="0.5px solid #E2E8F0"
      {...props}
    >
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">
        {children}
      </span>
    </div>
  );
};
